// extracted by css-extract-rspack-plugin
export default {"cls1":"JJHomePageSearch-cls1_TPr","cls2":"JJHomePageSearch-cls2_eoD JJHomePageSearch-cls1_TPr"};